const CANDIDATES = 'a[href], button, input, select, textarea, [tabindex]';
const NOT_TABBABLE = ':disabled, input[type="hidden"], [data-headlessui-focus-guard]';

/**
 * The element `Tab` (direction 1) or `Shift+Tab` (-1) reaches from `anchor`, in document order,
 * skipping anything inside `skip` (e.g. a floating panel). Null when there is none.
 */
export function adjacentTabbable(
  anchor: HTMLElement,
  direction: 1 | -1,
  skip?: Element | null
): HTMLElement | null {
  const all = Array.from(anchor.ownerDocument.querySelectorAll<HTMLElement>(CANDIDATES)).filter(
    element =>
      element === anchor ||
      (element.tabIndex >= 0 &&
        !element.matches(NOT_TABBABLE) &&
        !element.closest('[hidden], [inert]') &&
        !skip?.contains(element))
  );
  const index = all.indexOf(anchor);
  if (index === -1) return null;
  return all[index + direction] ?? null;
}
